<template>
  <div class="loading" v-show="isShow">
    <div class="loading-container">
      <div class="loading-box">
        <div class="loading-bubble-1"></div>
        <div class="loading-bubble-2"></div>
      </div>
      <div class="loading-text">{{text}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLoading',
  data(){
    return {
      isShow: false,
      text: '',
    }
  },
  created(){
  },
  methods: {
    
  },
  computed: {
    
  },
}
</script>

<style scoped lang="less">
  .loading {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0,0,0,.8);
    z-index: 999;
    .loading-text {
      padding: .4rem 0;
      color: #f3f3f3;
    }
    .loading-container {
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      z-index: 9999;
    }
    .loading-box {
      width: 45px;
      height: 45px;
      margin: 0 auto;
    }

    .loading-bubble-1,
    .loading-bubble-2 {
      position: absolute;
      top: 0;
      width: 25px;
      height: 25px;
      border-radius: 100%;
      background-color: #4b9cdb;
    }

    .loading-bubble-2 {
      top: auto;
      bottom: 0;
    }

    .loading-box {
      animation: k-loadingI 2s linear infinite;
    }

    .loading-bubble-1,
    .loading-bubble-2 {
      animation: k-loadingIb 2s ease-in-out infinite;
      background-color: #FFC107;
    }

    .loading-bubble-2 {
      animation-delay: -1.0s;
    }

    @keyframes k-loadingI {
      0% {
        transform: rotate(0);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes k-loadingIb {
      0%,
      100% {
        transform: scale(0);
      }
      50% {
        transform: scale(1);
      }
    }
  }
</style>